import React, { useEffect, useState } from 'react'
import logo from "../assets/logo/logo.jpg"
import { Link } from 'react-router-dom'
import kiruarts from "../assets/client/kiruarts.png"
import work from "../assets/images/work.png"
import { MakingMindsWorkspaceFooter, WorkspaceFaq } from '../route'
import MMFooter from '../components/Footer/MMFooter'
import NewsLetterWorkspace from '../pages/NewsLetter/NewsLetterWorkspace'

const WorkspaceMakingMinds = () => {

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };
    useEffect(() => {
        scrollToTop();
    }, []);
    return (
        <div>
            <nav className="bg-mwhite  border-gray-200 dark:bg-gray-900">
                <div className="flex flex-wrap justify-between items-center mx-auto max-w-screen-xl p-4">
                    <Link to="/" className="flex items-center space-x-3 rtl:space-x-reverse">
                        <img src={logo} className="h-8 mr-1" alt="logo" />
                        <span className="self-center text-2xl font-bold font-mfont dark:text-white">
                            Making Minds Technologies
                        </span>
                    </Link>
                    <div className="flex items-center space-x-2 rtl:space-x-reverse">
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" className="mt-0.5">
                            <rect width="24" height="24" fill="white" />
                            <circle cx="12" cy="12" r="9" stroke="#000000" strokeLinejoin="round" />
                            <path d="M12 3C12 3 8.5 6 8.5 12C8.5 18 12 21 12 21" stroke="#000000" strokeLinejoin="round" />
                            <path d="M12 3C12 3 15.5 6 15.5 12C15.5 18 12 21 12 21" stroke="#000000" strokeLinejoin="round" />
                            <path d="M3 12H21" stroke="#000000" strokeLinejoin="round" />
                            <path d="M19.5 7.5H4.5" stroke="#000000" strokeLinejoin="round" />
                            <g filter="url(#filter0_d_15_556)">
                                <path d="M19.5 16.5H4.5" stroke="#000000" strokeLinejoin="round" />
                            </g>
                            <defs>
                                <filter id="filter0_d_15_556" x="3.5" y="16" width="17" height="3" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset dy="1" />
                                    <feGaussianBlur stdDeviation="0.5" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_15_556" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_15_556" result="shape" />
                                </filter>
                            </defs>
                        </svg><a className="text-sm  text-mblack font-mfont dark:text-bmblack hover:underline">English</a>
                    </div>
                </div>
            </nav>
            <nav className="bg-mcolor ">
                <div className="max-w-screen-xl px-1 py-1 mx-auto">
                    <div className="flex flex-wrap   justify-between items-center mx-auto max-w-screen-xl p-2">
                        <Link to="/" className="flex items-center space-x-3 rtl:space-x-reverse">
                            {/* <img src={logo} className="h-8 mr-6" alt="logo" /> */}
                            <span className="self-center  text-mwhite text-2xl font-bold font-mfont dark:text-white">
                                Making Minds Technologies - Workspace
                            </span>
                        </Link>
                        <div className="hidden items-left sm:flex justify-end">

                            <ul className="flex  flex-row font-semibold mt-0 space-x-8 rtl:space-x-reverse text-md">
                                {/* <li>
                                    <a href="#" className="text-mwhite cursor-pointer font-mfont font-semibold dark:text-white hover:underline" >Partner with us</a>
                                </li> */}
                                <li>
                                    <Link to="/makingminds/products" className="text-mwhite cursor-pointer font-mfont font-semibold dark:text-white hover:underline" >Explore Products</Link>
                                </li>
                                <li>
                                    <a href="#customers" className="text-mwhite font-mfont font-semibold dark:text-white hover:underline" >Customers</a>
                                </li>
                                <li>
                                    <Link to="/contact" target='_blank' rel="noreferrer" className="text-mwhite font-mfont font-semibold dark:text-white hover:underline">Contact us</Link>
                                </li>
                                <li>
                                    <a href="#faq" className="text-mwhite font-mfont font-semibold dark:text-white hover:underline">FAQ</a>
                                </li>
                            </ul>
                        </div>
                    </div>

                </div>
            </nav>

            <section className="bg-mwhite dark:bg-gray-900 lg:m-10 m-3 mt-3">
                <div className="grid max-w-screen-xl px-4 py-8 mx-auto lg:gap-8 xl:gap-0 lg:py-16 lg:grid-cols-12">
                    <div className="mr-auto place-self-center lg:col-span-7">
                        <h1 className=" mb-4 text-4xl font-bold font-mfont tracking-tight leading-none md:text-4xl
             xl:text-6xl dark:text-white">
                            The better<br />
                            <span className='lg:text-6xl text-4xl'>way to office place.</span> </h1>
                        <p className="max-w-2xl mb-6 font-semibold font-mfont text-2xl text-black lg:mb-8 md:text-lg lg:text-xl 
            dark:text-gray-400">Making Minds Technologies Workplace elevates your team’s productivity by bringing together email, chat, docs,
                            calls, tasks, and more into the same space.</p>
                        <div className='flex'>
                            <a
                                href="/"
                                target="_blank"
                                rel="noreferrer"
                                className="inline-flex bg-mcolor hover:bg-mcolor py-3 uppercase my-1   mr-4 text-base font-medium transition  rounded-md hover:bg-shadow-1 text-mwhite px-7"
                            >
                                Get started
                            </a>
                            <a
                                href="/contact"
                                target="_blank"
                                rel="noreferrer"
                                className="inline-flex py-3  uppercase my-1 text-base font-medium text-white transition rounded-md bg-blue-800 px-7 hover:bg-opacity-90"
                            >
                                Contact Sales
                            </a>
                        </div>
                    </div>
                    <div className=" lg:mt-0 lg:col-span-5 lg:flex">
                        <img src={work} alt="mockup" className='' />

                    </div>
                </div>
            </section>
            <hr />
            <section className="py-8 px-8 lg:py-20 " id='customers'>
                <div className="container !mx-auto text-center place-content-center grid "  >
                    <p className="block text-xl font-mfont leading-relaxed text-mblack !font-semibold lg:!text-xl "   >
                        More than 50+ brands trust us
                    </p>
                    <h1
                        className="block antialiased tracking-normal font-mfont font-bold text-mblack my-4 !text-3xl !leading-snug lg:!text-3xl"
                    >
                        Trusted by Leading Brands
                    </h1>
                    <p
                        className="block antialiased font-mfont text-xl font-semibold leading-relaxed text-inherit mx-auto max-w-5xl !text-mblack lg:px-8 mb-10"
                    >
                        Our clientele ranges from creative startups to Fortune 500 businesses, each with its own set of particular difficulties that we have handled with success.
                    </p>
                    <div className="flex flex-col md:flex-row gap-6 max-w-6xl mx-auto"  >
                        {/* <div className="flex flex-col items-center justify-center gap-6"  >
                            <div className="relative flex flex-col bg-clip-border rounded-xl text-mblack bg-mcard px-10" >
                                <div className="p-6">
                                    <img src={kiruarts} alt="logo" className="w-40 mb-5" />
                                    <p
                                        className="block antialiased font-mfont text-sm leading-normal text-inherit font-normal text-gray-500"
                                    >
                                        kiruarts.vercel.app
                                    </p>
                                </div>
                            </div>
                            <div
                                className="relative flex flex-col bg-clip-border rounded-xl text-mblack bg-mcard px-10"        >
                                <div className="p-6">
                                    <img src="https://www.material-tailwind.com/logos/logo-amazon.svg" alt="logo" className="w-40" />
                                    <p
                                        className="block antialiased font-mfont text-sm leading-normal text-inherit font-normal text-gray-500"
                                    >
                                        amazon.com
                                    </p>
                                </div>
                            </div>
                        </div> */}
                        <div className="relative flex flex-col  rounded-xl text-mblack bg-mcard lg:px-10 justify-center max-w-[18rem] lg:max-w-lg"     >
                            <div className="p-6 text-center justify-center">
                                <img src={kiruarts} alt="logo" className="w-60 mb-5" />
                                <a href='https://kiruarts.vercel.app/' target='_blank' rel="noreferrer"
                                    className="block hover:text-blue-600 cursor-pointer mb-5 font-mfont text-lg leading-normal text-inherit font-medium text-mblack"
                                >
                                    kiruarts.vercel.app
                                </a>
                                <p
                                    className="block antialiased font-mfont text-sm leading-normal text-mblack font-normal lg:max-w-[16rem]"
                                >
                                    “It have broadened our horizons and helped me advance my career. The
                                    community is incredibly supportive."
                                </p>
                            </div>
                        </div>
                        {/* <div
                            className="flex flex-col items-center justify-center gap-6"
                        >
                            <div
                                className="relative flex flex-col bg-clip-border rounded-xl text-mblack bg-mcard px-10"
                            >
                                <div className="p-6">
                                    <img src="https://www.material-tailwind.com/logos/logo-spotify.svg" alt="logo" className="w-40" />
                                    <p
                                        className="block antialiased font-mfont text-sm leading-normal text-inherit font-normal text-gray-500"
                                    >
                                        spotify.com
                                    </p>
                                </div>
                            </div>
                            <div
                                className="relative flex flex-col bg-clip-border rounded-xl text-mblack bg-mcard px-10"
                            >
                                <div className="p-6">
                                    <img src="https://www.material-tailwind.com/logos/logo-google.svg" alt="logo" className="w-40" />
                                    <p
                                        className="block antialiased font-mfont text-sm leading-normal text-inherit font-normal text-gray-500"
                                    >
                                        google.com
                                    </p>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
                {/* <button
                    className="align-middle select-none bg-mblack font-mfont font-bold text-center
                     uppercase transition-all disabled:opacity-50 disabled:shadow-none 
                     disabled:pointer-events-none text-xs py-3 px-10 rounded-lg border
                      border-mblack text-mwhite hover:opacity-75 focus:ring 
                      focus:ring-gray-300 active:opacity-[0.85] mt-6 mx-auto flex "
                    type="button"
                    data-ripple-dark="true"
                >
                    see all products
                </button> */}
            </section>
            <hr />

            <div id='faq'>
                <WorkspaceFaq />
            </div>
            <NewsLetterWorkspace />
            <MakingMindsWorkspaceFooter />
            <MMFooter />
        </div >
    )
}

export default WorkspaceMakingMinds

